import cn from 'classnames';
import { useShimmerDataUrl } from 'hooks/common/use-shimmer-data-url';
import { Product } from 'interfaces/product';
import { ProductGallery } from 'modules/product-details/components/product-details-header';
import Image from 'next/image';
import Slider from 'react-slick';
import { generalImageLoader } from 'utils/image-loader';

interface PropTypes {
  classNames?: string;
  imageBackgroundColor?: string;
  images: ProductGallery[];
  product: Product;
  sliderRef: React.RefObject<Slider>;
  setSelectedGalleryItemIndex: React.Dispatch<React.SetStateAction<number>>;
}

const ImagesCarousel: React.FC<PropTypes> = ({
  classNames,
  imageBackgroundColor,
  images,
  product,
  sliderRef,
  setSelectedGalleryItemIndex,
}) => {
  const blurDataURL = useShimmerDataUrl({
    width: 64,
    height: 64,
  });
  return (
    <>
      {images.length !== 1 && (
        <div
          className={cn(
            'mt-3 hidden items-center gap-3 overflow-hidden overflow-x-scroll lg:flex',
            images.length <= 4 && 'justify-center',
            classNames
          )}
        >
          {images.map((image, index) => {
            if (!image.imageData) return null;
            return (
              <button
                key={index}
                className={cn(
                  'h-[132px] w-[132px] shrink-0 rounded-md p-1',
                  imageBackgroundColor
                )}
                onClick={() => {
                  setSelectedGalleryItemIndex(index);
                  sliderRef.current && sliderRef.current.slickGoTo(index);
                }}
              >
                <Image
                  src={image.imageData.originalSrc}
                  alt={image.imageData.altText || product.title}
                  placeholder="blur"
                  blurDataURL={blurDataURL}
                  className="rounded-md"
                  width={132}
                  height={132}
                  loader={generalImageLoader}
                />
              </button>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ImagesCarousel;
